import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateTiposPge () {
  return [
    {
      id: 'FACE',
      name: i18n.t('tipos.pge.face')
    },
    {
      id: 'FACEB2B',
      name: i18n.t('tipos.pge.faceb2b')
    },
    {
      id: 'OSAKIDETZA',
      name: i18n.t('tipos.pge.osakidetza')
    },
    // {
    //   id: 'CANARIAS',
    //   name: 'canarias'
    // },
    // {
    //   id: 'GALICIA',
    //   name: 'galicia'
    // },
    {
      id: 'GOBIERNOVASCO',
      name: i18n.t('tipos.pge.gobiernovasco')
    },
    // {
    //   id: 'CASTILLALEON',
    //   name: 'castillaleon'
    // },
    // {
    //   id: 'RIOJA',
    //   name: 'rioja'
    // },
    {
      id: 'CATALUNYA',
      name: i18n.t('tipos.pge.catalunya')
    },
    // {
    //   id: 'ANDALUCIA',
    //   name: 'andalucia'
    // },
    {
      id: 'VIZCAYA',
      name: i18n.t('tipos.pge.vizcaya')
    },
    {
      id: 'GUIPUZCOA',
      name: i18n.t('tipos.pge.guipuzcoa')
    },
    {
      id: 'ALAVA',
      name: i18n.t('tipos.pge.alava')
    },
    // {
    //   id: 'CAIXA',
    //   name: 'caixa'
    // },
    {
      id: 'BISCAYTIK',
      name: i18n.t('tipos.pge.biscaytik')
    },
    // {
    //   id: 'INDRA',
    //   name: 'indra'
    // },
    {
      id: 'TUCOMUNIDAD',
      name: i18n.t('tipos.pge.tucomunidad')
    },
    {
      id: 'EMAIL',
      name: i18n.t('tipos.pge.email')
    },
    {
      id: 'EXTERNO',
      name: i18n.t('tipos.pge.externo')
    },
  ]
}

function GenerateTiposPgeRecepcion () {
  return [
    {
      id: 'FACEB2B',
      name: i18n.t('tipos.pge.faceb2b')
    },
    {
      id: 'FACE',
      name: i18n.t('tipos.pge.face')
    },
    {
      id: 'OCR',
      name: i18n.t('tipos.pge.ocr')
    },
    {
      id: 'FILES',
      name: i18n.t('tipos.pge.files')
    },
    {
      id: 'MANUAL',
      name: i18n.t('tipos.pge.manual')
    },
    {
      id: 'AUTOFACTURA',
      name: i18n.t('tipos.pge.autofactura')
    },
    {
      id: 'EDASINVOIZE',
      name: i18n.t('tipos.pge.edasinvoize')
    }
  ]
}

function GenerateTiposPgeRecepcionIa () {
  return [
    {
      id: 'OCRIA',
      name: 'OCR IA'
    },
  ]
}

function GeneratePGERequireAdminCentre () {
  return ['FACE', 'OSAKIDETZA', 'GOBIERNOVASCO', 'CATALUNYA', 'VIZCAYA', 'GUIPUZCOA', 'ALAVA', 'BISCAYTIK']
}

function TIPOS_PGE_RECEPCION_IA (state) {
  return configHelper.getConfig(state, 'TIPOS_PGE_RECEPCION_IA', GenerateTiposPgeRecepcionIa)
}

function TIPOS_PGE (state) {
  return configHelper.getConfig(state, 'TIPOS_PGE', GenerateTiposPge)
}

function TIPOS_PGE_RECEPCION (state) {
  return configHelper.getConfig(state, 'TIPOS_PGE_RECEPCION', GenerateTiposPgeRecepcion)
}

function PGE_REQUIRE_ADMIN_CENTRE (state) {
  return configHelper.getConfig(state, 'PGE_REQUIRE_ADMIN_CENTRE', GeneratePGERequireAdminCentre, false)  
}

export {
  TIPOS_PGE,
  TIPOS_PGE_RECEPCION,
  PGE_REQUIRE_ADMIN_CENTRE,
  TIPOS_PGE_RECEPCION_IA
}
